import { render, staticRenderFns } from "./OnDemand.vue?vue&type=template&id=bd3ffb3c&scoped=true"
import script from "./OnDemand.vue?vue&type=script&lang=js"
export * from "./OnDemand.vue?vue&type=script&lang=js"
import style0 from "./OnDemand.vue?vue&type=style&index=0&id=bd3ffb3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3ffb3c",
  null
  
)

export default component.exports